import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-work-orders',
  templateUrl: './work-orders.component.html',
  styleUrls: ['./work-orders.component.scss']
})
export class WorkOrdersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
